import { render, staticRenderFns } from "./RegisterAmount.vue?vue&type=template&id=59729697"
import script from "./RegisterAmount.vue?vue&type=script&lang=js"
export * from "./RegisterAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports